import React, {FC, useState} from 'react';

import Map from '@geomatico/geocomponents/Map/Map';

/****** START OF COG SETUP ******/
import maplibregl, {StyleSpecification} from 'maplibre-gl';
import {cogProtocol} from '@geomatico/maplibre-cog-protocol';

maplibregl.addProtocol('cog', cogProtocol);

const sources: StyleSpecification['sources'] = {
  'imageSource': {
    type: 'raster',
    url: 'cog://https://cdn.geomatico.es/girona_image_cog_2.tiff',
    tileSize: 256
  }
};

const layers: StyleSpecification['layers'] = [{
  source: 'imageSource',
  id: 'imageLayer',
  type: 'raster'
}];

/****** END OF COG SETUP ******/


export type MainContentProps = {
  mapStyle: string
};

const GIRONA_INITIAL_VIEWPORT = {
  latitude: 41.974168,
  longitude: 2.853699,
  zoom: 12,
  bearing: 0,
  pitch: 0
};

const MainContent: FC<MainContentProps> = ({mapStyle}) => {
  const [viewport, setViewport] = useState(GIRONA_INITIAL_VIEWPORT);

  return <Map
    mapLib={maplibregl}
    mapStyle={mapStyle}
    viewport={viewport}
    onViewportChange={setViewport}
    sources={sources}
    layers={layers}
  />;
};

export default MainContent;
